export const educationPath = [
  {
    id: 'licence',
    title: 'Licence Professionnelle en Génie Informatique',
    titleEn: 'Professional Bachelor in Computer Engineering',
    school: 'Institut Universitaire SIANTOU',
    period: '2021 - 2022',
    year: '2022',
  },
  {
    id: 'bts',
    title: 'BTS en Génie Informatique',
    titleEn: 'BTS in Computer Engineering',
    school: 'Institut Universitaire SIANTOU',
    period: '2019 - 2021',
    year: '2019–21',
  },
  {
    id: 'bac',
    title: 'Baccalauréat Scientifique',
    titleEn: 'Scientific Baccalaureate',
    school: 'Lycée Bilingue de Bafoussam',
    period: '2018 - 2019',
    year: '2019',
  },
];
